import { library } from "@fortawesome/fontawesome-svg-core"
import { faBriefcase, fa2 } from "@fortawesome/free-solid-svg-icons"

library.add(faBriefcase, fa2 );